<template>
  <div class="v-search">
    <div class="v-search--icon i-search v-test" @click="toggleSearch()"></div>
    <div
      class="v-search__results"
      :class="{'v-search--slide': slideResults}"
      >
        <div class="v-search__input-container">
          <i class="v-search--icon i-search"></i>
            <input
              type="text"
              name="search-text"
              id="search-text"
              placeholder="search for products"
              @keyup.esc="searchText = '';toggleSearch()"
              @keyup="searchProducts()"
              v-model="searchText">
            <i class="v-search--icon v-search__close i-close" @click="toggleSearch()"></i>
        </div>

        <div
          class="v-top-searched"
          >
          <ProductItem
            v-for="(product, index) in topSearched"
            :key="index"
            :mainImage= "product.image ? product.image : ''"
            :hoverImage= "product.image_hover ? product.image_hover : ''"
            :title= "product.title ? product.title : ''"
            :price= "product.price ? product.price : 0"
            :priceCompare= "product.priceCompare ? product.priceCompare : ''"
            :handle= "product.handle ? product.handle : ''"
          />
        </div>
      </div>
  </div>
</template>

<script>
import ProductItem from "./product-item.vue"
import axios from "axios"

export default {
	selector: "#vue-search",
	components: {ProductItem},
  props: {
    topSearched: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    slideResults: false,
    searchText: ''
  }),
  methods: {
    toggleSearch() {
      this.slideResults=!this.slideResults
      document.getElementById('search-text').focus()
      if (this.slideResults) {
        document.querySelector('.screen-overlay-search').classList.add('show')
        document.querySelector('.klaviyo-newsletter').style.zIndex = 4
      } else {
        document.querySelector('.screen-overlay-search').classList.remove('show')
        document.querySelector('.klaviyo-newsletter').style.zIndex = 6
      }
    },
    async searchProducts() {
        // ,
        // auth: {
        //   username: '9cdcaa21a041255a5e10b0d693452e7f',
        //   password: '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'
        // }
      let data = JSON.stringify({
        query: `{
          products(first: 100, query: "title:*foil* OR tag:*foil* OR description:*foil*", sortKey: RELEVANCE) {
            edges {
              node {
                id
                title
                tags
              }
            }
          }
        }`,
        variables: {}
      })

      const response = await axios.post(
        `https://framar-canada.ca/admin/api/2021-07/graphql.json`,
        data,
        {
          headers: {
            'Content-Type': 'application/graphql',
            'X-Shopify-Access-Token': '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'
          }
        }
      )
      console.log(response)

    }
  }
}
</script>

<style lang="scss" scoped>
.v-test {
  opacity: 0;
}
.v-search {
  display: none;
  input {
    border: 0;
    outline: 0;
    width: 100%;
  }

  &--icon {
    font-size: 22px;
    cursor: pointer;
  }

  &__input-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__results {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: -1;
    opacity: 0;
    border-bottom: 1px solid #ccc;
    background-color: white;
    padding: 20px 50px;
    transition: top .3s ease-in-out;
    display: flex;
    flex-direction: column;
  }

  &--slide {
    bottom: unset;
    top: 0;
    z-index: 10;
    opacity: 1;
  }

  &__close {
    outline: 0;
    font-size: 30px;
    display: flex;
    transition: .25s ease-in-out;
    margin-bottom: 7px;
    &:hover {transform: rotate(90deg);}
  }
}

.v-top-searched {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 50px;
}
</style>